
import Login from './views/authentication/Login'

const routes = [
	{
		name: 'Login',
		layout: '/public',
		path: '/login',
		component: <Login />
	}
]

export default routes
